import localforage from 'localforage';
import { type BusinessProperty } from '../types';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

interface BusinessConfig {
    sixDigitPinEnabled?: boolean;
}

interface BusinessPropertyStore {
    config: BusinessConfig;
    update: (properties: BusinessProperty[]) => void;
    reset: VoidFunction;
}

export const useBusinessConfigStore = create(
    persist<BusinessPropertyStore>(
        (set) => ({
            config: {
                sixDigitPinEnabled: false,
            },
            update: (properties) => {
                const newConfig = parsePropertiesToConfig(properties);

                set({ config: { ...newConfig } });
            },
            reset: () => set({ config: { sixDigitPinEnabled: false } }),
        }),
        {
            name: 'business-properties',
            storage: createJSONStorage(() => localforage),
        },
    ),
);

export function parsePropertiesToConfig(properties: BusinessProperty[]) {
    const config: BusinessConfig = {};

    properties.forEach((property) => {
        if (property.key === 'SIX_DIGIT_PIN_ENABLED') {
            config.sixDigitPinEnabled = property.value === 'true';
        }
    });

    return config;
}
